module.exports = __webpack_public_path__ + "assets/ageRestrictionModalImg-69643b.svg";